import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import { Provider } from 'react-redux';
import { store } from "./redux/store"

import App from './App';
import { WidgetProvider } from './context/widgetContext';

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <WidgetProvider>
          <App />
      </WidgetProvider>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

